import React, { Fragment } from 'react'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Grow from '@material-ui/core/Grow'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'

import Categories, { getType } from '../../../../../const/BusinessTypes'

import DropDownIcon from '@material-ui/icons/ArrowDropDown'
import BrandIcon from '../../../../../static/images/categories/brand.svg'
import RetailIcon from '../../../../../static/images/categories/storefront.svg'
import ServiceIcon from '../../../../../static/images/categories/service.svg'
import InfluencerIcon from '../../../../../static/images/categories/influencer.svg'
import PersonalIcon from '../../../../../static/images/categories/personal.svg'
import BlankPinIcon from '../../../../../static/images/pins/blank.svg'

import styles from './styles'

const IconMap = {
  'Retail Stores': RetailIcon,
  Services: ServiceIcon,
  Brands: BrandIcon,
  Influencers: InfluencerIcon,
  Personal: PersonalIcon,
  Listings: BlankPinIcon,
  All: BlankPinIcon,
}

class BusinessesHeader extends React.Component {
  state = {
    open: false,
    contextOpen: false,
  }

  handleContextToggle = () => {
    this.setState(state => ({ contextOpen: !state.contextOpen }))
  }

  handleContextClose = event => {
    if (this.anchorElContext.contains(event.target)) {
      return
    }

    this.setState({ contextOpen: false })
  }

  handleToggle = () => {
    this.setState(state => ({ open: !state.open }))
  }

  handleTypeSwitch = type => {
    this.props.onTypeSwitch(type)
    this.handleToggle()
  }

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return
    }

    this.setState({ open: false })
  }

  render() {
    const {
      classes,
      selectedBusiness,
      children,
      title,
      onContextSwitch,
      contextTypeFilter,
    } = this.props
    const { open, contextOpen } = this.state
    const contextTitle = title === 'Brands' ? 'Brands' : 'Listings'
    const filterTitle = contextTypeFilter ? contextTypeFilter.title : 'All'
    return (
      <div className={classes.header}>
        <div className={classes.bar}>
          <Typography className={classes.title} variant="h6">
            <div className={classes.selectedMenu}>
              <span className={classes.titleText}>
                {selectedBusiness ? selectedBusiness.name : 'My Profiles'}
              </span>
            </div>
          </Typography>
          {!selectedBusiness && (
            <div className={classes.actions}>
              <div>
                <Button
                  buttonRef={node => {
                    this.anchorElContext = node
                  }}
                  aria-owns={contextOpen ? 'context-menu-list-grow' : undefined}
                  aria-haspopup="true"
                  onClick={this.handleContextToggle}
                  variant="outlined"
                  color="default"
                >
                  <img
                    src={IconMap[contextTitle]}
                    alt={contextTitle}
                    style={{ height: 24, width: 24, marginRight: 16 }}
                  />
                  Showing my {contextTitle}
                  <DropDownIcon className={classes.rightIcon} />
                </Button>
                <Popper
                  style={{ zIndex: 999 }}
                  open={contextOpen}
                  anchorEl={this.anchorElContext}
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      id="context-menu-list-grow"
                      style={{
                        transformOrigin:
                          placement === 'bottom'
                            ? 'center top'
                            : 'center bottom',
                      }}
                    >
                      <Paper>
                        <ClickAwayListener
                          onClickAway={this.handleContextClose}
                        >
                          <MenuList>
                            <MenuItem
                              onClick={() => onContextSwitch(Categories.RETAIL)}
                            >
                              <img
                                src={BlankPinIcon}
                                alt={title}
                                style={{
                                  height: 24,
                                  width: 24,
                                  marginRight: 16,
                                }}
                              />
                              Listings
                            </MenuItem>

                            <MenuItem
                              onClick={() => onContextSwitch(Categories.BRAND)}
                            >
                              <img
                                src={BrandIcon}
                                alt={title}
                                style={{
                                  height: 24,
                                  width: 24,
                                  marginRight: 16,
                                }}
                              />
                              Brands
                            </MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </div>
              {contextTitle === 'Listings' && (
                <Fragment>
                  <div className={classes.typeFilter}>
                    <Button
                      buttonRef={node => {
                        this.anchorEl = node
                      }}
                      aria-owns={open ? 'menu-list-grow' : undefined}
                      aria-haspopup="true"
                      onClick={this.handleToggle}
                      variant="outlined"
                      color="default"
                    >
                      <img
                        src={IconMap[filterTitle]}
                        alt={filterTitle}
                        style={{ height: 24, width: 24, marginRight: 16 }}
                      />
                      Filtering by {filterTitle}
                      <DropDownIcon className={classes.rightIcon} />
                    </Button>
                    <Popper
                      style={{ zIndex: 999 }}
                      open={open}
                      anchorEl={this.anchorEl}
                      transition
                      disablePortal
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          id="menu-list-grow"
                          style={{
                            transformOrigin:
                              placement === 'bottom'
                                ? 'center top'
                                : 'center bottom',
                          }}
                        >
                          <Paper>
                            <ClickAwayListener onClickAway={this.handleClose}>
                              <MenuList>
                                <MenuItem
                                  onClick={() => this.handleTypeSwitch('All')}
                                >
                                  <img
                                    src={BlankPinIcon}
                                    alt={title}
                                    style={{
                                      height: 24,
                                      width: 24,
                                      marginRight: 16,
                                    }}
                                  />
                                  All
                                </MenuItem>
                                <MenuItem
                                  onClick={() =>
                                    this.handleTypeSwitch(Categories.RETAIL)
                                  }
                                >
                                  <img
                                    src={RetailIcon}
                                    alt={title}
                                    style={{
                                      height: 24,
                                      width: 24,
                                      marginRight: 16,
                                    }}
                                  />
                                  {getType(Categories.RETAIL).title}
                                </MenuItem>
                                <MenuItem
                                  onClick={() =>
                                    this.handleTypeSwitch(Categories.SERVICE)
                                  }
                                >
                                  <img
                                    src={ServiceIcon}
                                    alt={title}
                                    style={{
                                      height: 24,
                                      width: 24,
                                      marginRight: 16,
                                    }}
                                  />
                                  {getType(Categories.SERVICE).title}
                                </MenuItem>
                                <MenuItem
                                  onClick={() =>
                                    this.handleTypeSwitch(Categories.INFLUENCER)
                                  }
                                >
                                  <img
                                    src={PersonalIcon}
                                    alt={title}
                                    style={{
                                      height: 24,
                                      width: 24,
                                      marginRight: 16,
                                    }}
                                  />
                                  {getType(Categories.INFLUENCER).title}
                                </MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </div>
                </Fragment>
              )}
            </div>
          )}
        </div>

        <div className={classes.headerUI}>{children}</div>
      </div>
    )
  }
}

export default withStyles(styles)(BusinessesHeader)



// WEBPACK FOOTER //
// ./src/components/account/businesses/Businesses/Header/index.js